import React, { useMemo } from 'react';
import { Typography, Dialog, DialogContent, DialogTitle, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import History from 'components/common/History';
import { useLazyGetPersonalCareHistoryQuery } from 'store/services/personalCare';
import { HISTORY_ACTIONS } from './PcConst';
import { useLazyGetTimeSheetHistoryQuery } from 'store/services/activityTimeEntry';

export default function ViewModal({ pcId, handleClose }) {
    const open = Boolean(pcId);

    const historyData = useLazyGetTimeSheetHistoryQuery();

    const historyPayload = useMemo(
        () => ({
            filters: {
                time_entry_id: pcId
            }
        }),
        [pcId]
    );

    return (
        <>
            <Dialog open={open} fullWidth maxWidth="md" onClose={handleClose}>
                <DialogTitle sx={{ p: 2 }}>
                    <Typography variant="h4">Time Sheet History</Typography>
                    <IconButton
                        onClick={handleClose}
                        sx={{ position: 'absolute', top: 10, right: 10, color: (theme) => theme.palette.grey[500] }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ m: 0, pt: 1 }}>
                    {pcId && <History data={historyData} payload={historyPayload} actions={HISTORY_ACTIONS} />}
                </DialogContent>
            </Dialog>
        </>
    );
}